import {
  get /* , post, put, upload, uploadPut, del, patch  */,
} from '@api/request';

export async function fetchAppraiserCases({ litigationService }, authenticationToken, { email }) {
  const url = `${litigationService}/litigation/arbitrations/assignedto/${email}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraiserLitigationCases({ litigationService }, authenticationToken, { id }) {
  const url = `${litigationService}/litigation/mycases/${id}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/user/appraisal/byattribute/Appraiser`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchUsers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/user/appraisal/byattribute/All`;
  const { body } = await get(authenticationToken, url);
  return body;
}
